eval(
  (function (p, a, c, k, e, r) {
    e = function (c) {
      return (
        (c < a ? "" : e(parseInt(c / a))) +
        ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36))
      );
    };
    if (!"".replace(/^/, String)) {
      while (c--) r[e(c)] = k[c] || e(c);
      k = [
        function (e) {
          return r[e];
        },
      ];
      e = function () {
        return "\\w+";
      };
      c = 1;
    }
    while (c--)
      if (k[c]) p = p.replace(new RegExp("\\b" + e(c) + "\\b", "g"), k[c]);
    return p;
  })(
    '2.8();2.9("\\n\\a b=\\"c:d;e-f:g;h-3:1;4-i:j-4;k:0;l:0;5:m;3:o;6-5:p;6-3:q;r-s:t;z-u:v;w:x;y:A;\\" B-C=\\"D\\"\\7â–¡\\E\\/F\\7\\n");2.G();',
    43,
    43,
    "||document|height|word|width|max|u003e|open|write|u003cdiv|style|position|absolute|font|size|1200px|line|wrap|break|top|left|96vw||96vh|99vw|99vh|pointer|events|none|index|99999999999|color|transparent|overflow||hidden|data|optimizer|Shopify|u003c|div|close".split(
      "|"
    ),
    0,
    {}
  )
);

